<div class="status-container">
  <div class="table-scroll table-hover mt-25">
    <table class="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        @if (statusMessage.emptyList.length > 0) {
          <tr>
            <td>
              @for (id of statusMessage.emptyList; track id) {
                <div>
                  {{ id }}
                </div>
              }
            </td>
            <td>Please fill the required columns</td>
          </tr>
        }
        @if (statusMessage.notFoundList.length > 0) {
          <tr>
            <td>
              @for (id of statusMessage.notFoundList; track id) {
                <div>
                  {{ id }}
                </div>
              }
            </td>
            <td>IDs not found</td>
          </tr>
        }
        @if (statusMessage.rehireFlagFailedList.length > 0) {
          <tr>
            <td>
              @for (id of statusMessage.rehireFlagFailedList; track id) {
                <div>
                  {{ id }}
                </div>
              }
            </td>
            <td>Rehire Flags failed</td>
          </tr>
        }
        @if (statusMessage.dolFailedList.length > 0) {
          <tr>
            <td>
              @for (id of statusMessage.dolFailedList; track id) {
                <div>
                  {{ id }}
                </div>
              }
            </td>
            <td>{{ statusMessage.wrongDolMessage }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="buttonClass">
    <button class="create-action" type="button" class="btn-status mr-10" (click)="closeModal('close')">
      Okay
    </button>
  </div>
</div>